if (typeof window.gtag === 'function') {
  const gtagOrig = window.gtag;
  // @ts-expect-error override!
  window.gtag = (...args) => {
    console.debug(`gtag(): ${JSON.stringify(args)}`);
    gtagOrig(...args);
  };
}
